import config from '../config';

export interface ThreadContact {
  contactId: string;
  previousContactId: string | null;
  initiationMethod: string;
  initiationTimestamp: string;
  disconnectTimestamp: string | null;
}

export const fetchEmailThread = async (contactId: string): Promise<ThreadContact[]> => {
  const apiUrl = config.emailApiUrl;

  if (!apiUrl) {
    throw new Error('Email API Url is not configured');
  }

  const params = new URLSearchParams({ contactId });

  const response = await fetch(`${apiUrl}/thread?${params.toString()}`, {
    method: 'GET'
  });

  if (!response.ok) throw new Error(`API responded with status ${response.status}`);

  const json = (await response.json()) as { meta: { version: string }; data: ThreadContact[] };
  return json.data ?? [];
};
